module.exports = __webpack_public_path__ + "img/ff01.da626e7a.png";